<template>
  <base-section
    ref="menu"
    class="text-center"
  >
    <base-section-heading title="Die Welt gehört dem der sie genießt (Giacomo Leopardi)!">
      <p><b>Öffnungszeiten:</b> Montag und Freitag von 07:00 Uhr bis 15.00 Uhr</p>
      <p>Sie möchten etwas für den kleinen Hunger zwischendurch? Oder darf es doch lieber etwas Reichhaltigeres sein? Kein Problem! Wir bieten Ihnen kleine Snacks, belegte Brote, Salatteller, Tagesgerichte und eine Auswahl an Getränken. </p>
    </base-section-heading>
    <v-container id="pricing-plan">
      <v-row justify="center">
        <v-col
          v-for="_category in categories"
          :key="_category.id"
          cols="auto"
        >
          <v-btn
            color="primary"
            tile
            :outlined="category != _category.id "
            @click="setCategory(_category.id)"
          >
            {{ _category.name }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <div class="pa-8" />

    <v-container>
      <!-- <h2>Liebe Kunden,
        <br>unsere Bar bleibt auf Grund der neusten Verordnung vorübergehend geschlossen. Wir halten Euch natürlich auf dem Laufenden.
        <br>Bleibt gesund und wir sehen uns hoffentlich bald wieder.
        <br>
        Liebe Grüße,
        <br>
        <br>
        <br>
        Anna Lena, Berta und Monika.</h2> -->
      <v-row v-if="products.length">
        <v-col
          v-for="(product, i) in filteredProducts"
          :key="i"
          cols="12"
          md="4"
        >
          <menu-card v-bind="product" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <h3>Produkte werden geladen..</h3>

          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Menu',

    components: {
      MenuCard: () => import('@/components/MenuCard'),
    },

    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      category: undefined,
      dialog: false,
    }),
    computed: {
      ...mapGetters([
        'products',
        'categories',
      ]),
      filteredProducts () {
        if (typeof this.category !== 'undefined') {
          return this.products.filter(product => {
            return product.categories.find(category => category.id === this.category)
          })
        } else {
          return this.products
        }
      },
    },
    mounted () {
      const now = new Date().getHours() + (new Date().getMinutes() / 60)

      switch (true) {
        case (now > 14):
          this.category = 6
          break
        case (now < 8.5):
          this.category = 5
          break
        case (now < 10):
          this.category = 2
          break
        case (now < 14):
          this.category = 1
          break
        default:
          this.category = undefined
      }
      this.$store.dispatch('getProducts')
      this.$store.dispatch('getCategories')
    },
    methods: {
      setCategory (id) {
        if (this.category === id) {
          this.category = undefined
        } else {
          this.category = id
        }
      },
    },

  }
</script>
